import bem from 'utils/bem';

export const block = bem('text-overlay-make-text-dynamic-card');
